import { getRgObjectsOfType as r, RG_TYPE as t } from "@project-rouge/rg-core";
import { isServiceTechSpace as i } from "../../queries/index7.js";
import { getPerimeter as c } from "../index8.js";
const f = (e) => c(r(e, t.TechnicalSpace).filter(i));
export {
  f as getServicesPerimeter
};
//# sourceMappingURL=index54.js.map
